class ConsoleUtil {
    static red(message: string, object?: any) {
        this.logWithColor(message, 0xfc2c03, object);
    }

    static yellow(message: string, object?: any) {
        this.logWithColor(message, 0xfce703, object);
    }

    static orange(message: string, object?: any) {
        this.logWithColor(message, 0xff7300, object);
    }

    static green(message: string, object?: any) {
        this.logWithColor(message, 0x00ff66, object);
    }

    static logWithColor(message: string, color: number | string, object?: any) {
        let convertedColor: string; 
        
        if (typeof color == "string") {
          convertedColor = color;
        } else {
          convertedColor =
              "#" + ("00000" + (color | 0).toString(16)).substr(-6);
        }

        this.log(
            "%c" + message,
            "color:" + convertedColor + ";font-weight:bold;"
        );
        if (object) {
            this.log("\t", object);
        }
    }

    static log(...data:any[]) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(...data);
        }
    }

    static warn(...data:any[]) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(...data);
        }
    }

    static error(...data:any[]) {
        if (process.env.NODE_ENV !== 'production') {
            console.error(...data);
        }
    }

    static enableConsoleOverlay(top: number = 50): void {
        const id = "debugLog";
        if (document.getElementById(id)) {
            return;
        }
        
        var log = document.createElement('div');
        log.id = id;
        log.style.cssText = `position: absolute; top: ${top}px; left: 0; height: 30vh; width: 100%; overflow: auto; background-color:rgba(255, 255, 255, 0.85); color:black; resize: vertical;`;
        let checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = "debugLogAutoscroll";
        checkbox.style.cssText = `position: absolute; top: ${top}px; right: 20px`;
        checkbox.checked = true;

        let label = document.createElement("label");
        label.htmlFor = "debugLogAutoscroll";
        label.textContent = "Autoscroll";
        label.style.cssText = `position: absolute; top: ${top}px; right: 40px`;
        document.body.appendChild(log);
        document.body.appendChild(checkbox);
        document.body.appendChild(label);

        ['log','debug','info','warn','error'].forEach(function (verb) {
            console[verb] = (function (method, verb, log) {
                return function () {
                    method.apply(console, arguments);
                    var msg = document.createElement('div');
                    msg.classList.add(verb);
                    msg.textContent = Array.prototype.slice.call(arguments).join(' ');

                    // Paring the css style
                    if (msg.textContent.startsWith("%c")) {
                        let index = msg.textContent.lastIndexOf(' ');
                        if (index) {
                            let style = msg.textContent.substring(index);
                            msg.style.cssText = style;
                            msg.textContent = msg.textContent.substring(2, index); 
                        }
                    }

                    if (verb == "warn") {
                        msg.style.backgroundColor = "rgba(255,150,0, 0.3)";
                    }

                    log.appendChild(msg);
                    if (checkbox.checked) {
                        // Auto scroll to bottom
                        log.scrollTop = log.scrollHeight;
                    }
                };
            })(console[verb], verb, log);
        });
    }
}

export default ConsoleUtil;
